import { createEvent, restore, sample } from 'effector'
import { DemoContestRequest, DemoContestResponse, DemoContest } from './types'
import { fx } from '../../../libs'
import { isAllElementsOfSearchTextNotExist } from '../../../libs/utils'

const DATE_FIELDS = ['registrationAt', 'activatesAt', 'endsAt']

const changedDateFormat = (date: Date) =>
  `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`

const mapSearchEntry = (key: string, value: any): [string, any] => {
  if (DATE_FIELDS.includes(key)) {
    const dates = Array.isArray(value)
      ? value.map((date) => (date ? changedDateFormat(date?.$d) : `${date}`))
      : value
    return [key, dates]
  }

  return [key, value?.toLowerCase()]
}

const mapSearchText = (searchText: { [key: string]: string }) => {
  return Object.fromEntries(
    Object.entries(searchText).map(([key, value]) =>
      mapSearchEntry(key, value),
    ),
  )
}

export const demoContestListMounted = createEvent<DemoContestRequest>()

export const getDemoContestList = fx<DemoContestRequest, DemoContestResponse>({
  method: 'GET',
  url: `/contest`,
})

export const $demoContestList = restore<DemoContest[]>(
  getDemoContestList.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfDemoContestList = restore(
  getDemoContestList.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: demoContestListMounted,
  fn: ({ limit, page, orderBy, orderDirection, searchText, filters }) => {
    if (orderDirection === 'descend') {
      orderDirection = '-'
    } else if (orderDirection === 'ascend') {
      orderDirection = ''
    }
    console.log('searchText', searchText)
    let query = {
      limit,
      page,
    }

    if (orderBy) {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }

    if (filters) {
      //TODO данные мапперы необходимо переписать, когда бэк будет паринимать правильный JSON
      let newObj = Object.keys(filters).reduce((accumulator, key) => {
        if (filters[key as keyof typeof filters] != null) {
          accumulator[key as keyof typeof filters] =
            //TODO
            key === ''
              ? filters[key as keyof typeof filters]
              : `${filters[key as keyof typeof filters]}`
        }

        return accumulator
      }, {} as any)

      if (!isAllElementsOfSearchTextNotExist(searchText)) {
        newObj = { ...newObj, ...mapSearchText(searchText) }
      }

      if (Object.keys(newObj).length) {
        // @ts-ignore
        query['where'] = `${JSON.stringify(newObj)}`
      }
    }

    return {
      query,
    }
  },
  target: getDemoContestList,
})
